import { useCallback, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'

import { getItemsIds } from '../../../../utils/common'

export function useEntityProfileTabsActiveTab({
  getTabUrl,
  isEntityLoaded,
  preparedTabs,
}) {
  const navigate = useNavigate()

  const location = useLocation()

  const { tab: tabFromUrl } = useParams()

  const availableTabIds = getItemsIds(preparedTabs)

  const defaultTabId = preparedTabs[0]?.id

  // Use the URL's tab only when it's one this user can access; otherwise fall
  // back to their first available tab.
  const isUrlTabAvailable =
    Boolean(tabFromUrl) && availableTabIds.includes(tabFromUrl)

  const activeTabId = isUrlTabAvailable ? tabFromUrl : defaultTabId

  // Once the entity (and its permissions) have loaded, reflect the resolved
  // active tab in the URL whenever it's missing or names a tab the user can't
  // access — so the active tab is always shareable and never points at a tab
  // the user lacks. Preserve the current search/hash so deep-link params
  // (e.g. sub-tab) aren't dropped.
  useEffect(() => {
    if (isEntityLoaded && activeTabId && tabFromUrl !== activeTabId) {
      navigate(
        {
          hash: location.hash,
          pathname: getTabUrl(activeTabId),
          search: location.search,
        },
        { replace: true }
      )
    }
  }, [activeTabId, isEntityLoaded, location.hash, location.search, tabFromUrl])

  const handleSetActiveTab = useCallback(
    tabId => {
      navigate(getTabUrl(tabId), { replace: true })
    },
    [getTabUrl, navigate]
  )

  return {
    activeTabId,
    handleSetActiveTab,
  }
}
